import { Divider, Grid, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { convertKeysToLowerCase } from '../../../utils/constants';
import styles from '../../../assets/styles/componentStyles/carouselCard.module.scss';
import carouselStyles from '../../../assets/styles/componentStyles/widgetComponentStyles/dynamicCarousel.module.scss'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

const CardCarouselDynamicFormatCTA = (props: any) => {
    const { handleMouseDown, handleMouseUp, image, handleActionButton, getActionButtonIcon, chatbotTheme, threadData, flagVideo } = props;
    const [currentCartData, setCurrentCardData] = useState(() => {
        const defaultVariants = image?.variants?.filter((data: any) => data.flag_default === true);
        if (defaultVariants?.length > 0) {
          return defaultVariants[0];
        }
        return image?.variants?.length > 0 ? image.variants[0] : null;
    });

    const [showArrow, setShowArrow] = useState(true);
    const [arrowClicked, setArrowClicked] = useState(false);
    const scrollContainerRef = useRef(null);
    const [count, setCount] = useState(0);

    const handleScroll = () => {
        const container = scrollContainerRef.current;
        if(!arrowClicked) {
            if (container) {
                //@ts-ignore
                const isAtBottom = container.scrollHeight - container.scrollTop === container.clientHeight;              
                setShowArrow(!isAtBottom);
            }
        }
        if(container) {
            //@ts-ignore
            const isAtTop = container.scrollTop === container.scrollHeight - container.clientHeight;
            setShowArrow(!isAtTop);
        }
    };

    const scrollDown = () => {
        const container = scrollContainerRef.current;
        if (container) {
        // const scrollAmount = container.scrollHeight || container.offsetHeight || 100;
        const scrollAmount = 95;
          //@ts-ignore
          container.scrollBy({
            top: scrollAmount,
            // top: container.scrollHeight,
            behavior: "smooth",
          });
          setShowArrow(false)
          setCount(count+1);
          if(count >= 3) {
            setArrowClicked(true)
          }
        }
    };

    const CalculateTotalCards = (currentCardData: any) => {
        const countField = (fieldName: any) => {
            const field = currentCardData?.variant_data?.find((d: any) => d.field_name === fieldName);
            const value = field?.field_value;

            if (Array.isArray(value)) {
                return value.filter(v => typeof v === 'string' ? v.trim() !== '' : !!v).length;
            }
            else if (typeof value === 'string') {
                // Could be empty, single URL, or comma‑separated
                const parts = value
                    .split(',')
                    .map(s => s.trim())
                    .filter(Boolean);       // remove empty strings
                return parts.length;
            }
            else {
                return 0;
            }
        };

        const imgCount = countField("image_url");
        const vidCount = countField("video_url");

        return imgCount + vidCount;
    };

    const renderStrikethrough = (value: any, strikethroughValue: any, isBefore: any) => {
        const isValidValue = (value !== "" && value !== "-");
        const strikethroughSpan = (
            <span className={isValidValue ? isBefore ? styles.lineThroughTextBefore : styles.lineThroughText : ""}>
                {strikethroughValue}
            </span>
        );
        return (
            <span>
                {isBefore ? (
                    <>{strikethroughSpan}{isValidValue && ` ${value}`}</>
                ) : (
                    <>{isValidValue && `${value} `}{strikethroughSpan}</>
                )}
            </span>
        );
    };


    function getDynamicValue (dynamic: any) {
        if (!dynamic) {
            return "-";
        }

        // Case 1: URL flag is ON
        if (dynamic?.flag_url) {
            return dynamic?.url_text !== "" ? dynamic?.url_text : dynamic?.field_value;
        }
        // Case 2: Empty or []
        else if (dynamic?.field_value === "" || dynamic?.field_value === "[]") {
            return "-";
        }

        // Case 3: Strikethrough block
        else if (dynamic?.strikethrough && dynamic?.strikethrough?.flag_show) {
            const { field_strikethrough_value, flag_strikethrough_first } = dynamic.strikethrough;
                return renderStrikethrough (
                    dynamic.field_value,
                    field_strikethrough_value,
                    flag_strikethrough_first
                );
            }
            // Case 4: Default
            else {
                return dynamic?.field_value;
            }
        }

    function isShowVideoPriority() {
        if (!flagVideo) return false;

        const priority = currentCartData?.priority?.toLowerCase();
        if (priority !== "video") return false;

        const videoField = currentCartData?.variant_data?.find(
            (data: any) => data.field_name === "video_url"
        );

        if (!videoField) return false;
        if (videoField.field_value === "") return false;

        return true;
    }

    const getDynamicFields = () => {
        const dynamicFields =
            currentCartData?.variant_data?.filter(
                (data: any) => data?.field_flag_dynamic
            ) || [];

        const softcover = dynamicFields.find(
            (item: any) => item.field_name === "product_softcover_price_sale_price"
        );

        const hasValidSoftcover =
            softcover &&
            (
                (
                    softcover.field_value &&
                    softcover.field_value.trim() !== "" &&
                    softcover.field_value !== "-"
                ) ||
                (
                    softcover.strikethrough?.flag_show &&
                    softcover.strikethrough?.field_strikethrough_value &&
                    softcover.strikethrough.field_strikethrough_value.trim() !== "" &&
                    softcover.strikethrough.field_strikethrough_value !== "-"
                )
            );

        return dynamicFields.filter((item: any) => {
            if (hasValidSoftcover && item.field_name === "product_hardcover_price_sale_price") {
                return false;
            }

            if (item.field_name === "product_softcover_price_sale_price" && !hasValidSoftcover) {
                return false;
            }

            return true;
        });
    };

    return (
        <Grid container>
            <Grid item xs={12} sx={{ padding: '0px' }}>
                <Grid container>
                    <Grid item xs={12} className={styles.chat_crl_img_item} sx={{borderBottom: "1px solid #EAEAEA" }}>
                        {/* {flagVideo && currentCartData?.priority?.toLowerCase() == "video" && currentCartData?.variant_data?.find((data: any) => data.field_name === "video_url") && currentCartData?.variant_data?.find((data: any) => data.field_name === "video_url")?.field_value != "" ? */}
                        {isShowVideoPriority() ?
                            <video controls autoPlay muted loop className={carouselStyles.dynamic_image_style}
                                onMouseDown={handleMouseDown}
                                onMouseUp={(event) =>
                                    handleMouseUp(
                                        event,
                                        image?.variants?.find((data: any) => data.flag_default === true) ||
                                            (image?.variants ? image?.variants[0] : null),
                                        true
                                    )
                                }
                            >
                                <source 
                                    type="video/mp4" 
                                    src={
                                        (() => {
                                            const fieldData = currentCartData?.variant_data?.find(
                                                (data: any) => data.field_name === "video_url"
                                            );
                                            const value = fieldData?.field_value;
                                            if (Array.isArray(value)) {
                                                return value.length > 0
                                                    ? value[0]
                                                    : "https://storage.googleapis.com/storage.writewiz-staging.in/chronox/general/sample_video.mp4";
                                            } 
                                            else if (typeof value === "string") {
                                                const urls = value.split(",").map((s) => s.trim()).filter(Boolean);
                                                return urls.length > 0
                                                    ? urls[0]
                                                    : "https://storage.googleapis.com/storage.writewiz-staging.in/chronox/general/sample_video.mp4";
                                            } 
                                            else {
                                                return "https://storage.googleapis.com/storage.writewiz-staging.in/chronox/general/sample_video.mp4";
                                            }
                                        })()
                                    }
                                />
                            </video>
                            :
                            <img
                                onMouseDown={handleMouseDown}
                                onMouseUp={(event) => handleMouseUp(event, image?.variants?.find((data: any) => data.flag_default === true) || image?.variants ? image?.variants[0] : null, true)}
                                src={
                                    (() => {
                                        const fieldData = currentCartData?.variant_data?.find((data: any) => data.field_name === "image_url");
                                        const value = fieldData?.field_value;

                                        if (Array.isArray(value)) {
                                            return value.length > 0
                                                ? value[0]
                                                : "https://storage.googleapis.com/storage.writewiz-staging.in/chronox/general/medical_(3)_1726065948494.png";
                                        } 
                                        else if (typeof value === "string") {
                                            // Handle comma-separated strings
                                            const urls = value.split(",").map((s) => s.trim()).filter(Boolean);
                                                return urls.length > 0
                                                    ? urls[0]
                                                    : "https://storage.googleapis.com/storage.writewiz-staging.in/chronox/general/medical_(3)_1726065948494.png";
                                        } 
                                        else {
                                            return "https://storage.googleapis.com/storage.writewiz-staging.in/chronox/general/medical_(3)_1726065948494.png";
                                        }
                                    })()
                                }
                                alt=""
                                loading='lazy'
                                className={carouselStyles.dynamic_image_style}
                                style={{objectFit :image?.flag_image_compact?"scale-down": "cover", objectPosition:image?.flag_image_compact?"center": "top"}}
                            />
                        }
                    </Grid>
                    {flagVideo &&
                        <Grid item className={carouselStyles.dynamic_image_count_style} sx={{ background: chatbotTheme?.system_msg_bg_color ? chatbotTheme?.system_msg_bg_color : "#fff" }}>
                            {`1/${CalculateTotalCards(currentCartData)}`}
                        </Grid>
                    }

                    <Grid item xs={12} sx={{ cursor: "pointer", height: "100%", position: "relative", paddingTop: "0px", borderRadius: convertKeysToLowerCase(currentCartData)?.cta_buttons && convertKeysToLowerCase(currentCartData)?.cta_buttons.length > 0 ? "0px" : "0px 0px 10px 10px", background: chatbotTheme?.system_msg_bg_color ? chatbotTheme?.system_msg_bg_color : "#fff"}} mb={convertKeysToLowerCase(currentCartData)?.cta_buttons && convertKeysToLowerCase(currentCartData)?.cta_buttons.length > 0 ? 0 : 1}>
                        <Grid container sx={{marginBlock: "7px 4px !important" }}>
                            <Grid item xs={12} className={carouselStyles.lower_section_carousel_style} ref={scrollContainerRef} onScroll={handleScroll}>
                                {showArrow && threadData?.flag_arrow && <KeyboardDoubleArrowDownIcon onClick={scrollDown} className={carouselStyles.blinking_arrow} />}
                                <Grid container>
                                    <Grid item xs={12} sx={{ paddingRight: "0px !important", overflowY: "auto", margin: "0 !important" }}>
                                        <Grid container>
                                            <Grid item xs={12} sx={{ margin: '5px 0px 0px', padding: '5px 9px 5px', width: "100%" }}>
                                                <Grid container direction={"column"} alignItems={"start"}>

                                                    <Grid item mb={currentCartData?.variant_data?.find((data: any) => data.field_name === "product_description") ? "" : "10px"}>
                                                        <Typography
                                                            component="span"
                                                            className={`${carouselStyles.global_textfield_common_style} ${carouselStyles.primary_textfield_style}`}
                                                            sx={{color: image?.item_style?.header_color ? `${image?.item_style?.header_color}` : "#000"}}
                                                        >
                                                            {`${currentCartData?.variant_data?.find((data: any) => data.field_name === "product_name")?.field_value} `}
                                                        </Typography>
                                                    </Grid>

                                                    {currentCartData?.variant_data?.find((data: any) => data.field_name === "product_description") &&
                                                        <Grid item mt={"5px"} mb={"5px"}>
                                                            <Typography
                                                                component="span"
                                                                className={`${carouselStyles.global_textfield_common_style} ${carouselStyles.ternary_textfield_style} ${carouselStyles.ternary_textfield_light_style}`}
                                                            >
                                                                {currentCartData?.variant_data?.find((data: any) => data.field_name === "product_description")?.field_value}
                                                            </Typography>
                                                        </Grid>
                                                    }

                                                    {
                                                        getDynamicFields().map((dynamic: any, ind: number) => 
                                                            <Grid key={ind} item mt={"6px"} xs={12} sx={{width: "100%"}}>
                                                                <Grid container justifyContent={"space-between"}>
                                                                    {dynamic.field_label !== "" && !dynamic?.flag_parse_and_create &&
                                                                        <Grid item className={carouselStyles.ternary_dark_textfield_style} xs={5}>
                                                                            {dynamic.field_label}
                                                                        </Grid>
                                                                    }
                                                                    <Grid item className={carouselStyles.ternary_dark_textfield_style} xs={dynamic.field_label !== "" && !dynamic?.flag_parse_and_create ? 7 : 12}>
                                                                        {dynamic?.flag_parse_and_create ? 
                                                                            Array.isArray(dynamic.field_value) ?
                                                                            dynamic.field_value.map((fieldvalues: any, index: any) => (
                                                                                <ul key={index} className={carouselStyles.dynamic_list_style}>
                                                                                    <li>
                                                                                        {Object.values(fieldvalues)[0] as String}
                                                                                        <ul className={carouselStyles.dynamic_sub_list_style}>
                                                                                            {Object.entries(fieldvalues)
                                                                                                .slice(1)
                                                                                                .map(([key, value], indexx) => (
                                                                                                    <li key={index+indexx}>
                                                                                                        {key}: 
                                                                                                        <span 
                                                                                                            className={carouselStyles.ternary_textfield_style}
                                                                                                            style={{color: image?.item_style?.field_value_color ? `${image?.item_style?.field_value_color}` : "#7A7A7A"}}
                                                                                                        >
                                                                                                            {` ${value}`}
                                                                                                        </span>
                                                                                                    </li>
                                                                                                ))}
                                                                                        </ul>
                                                                                    </li>
                                                                                </ul>
                                                                            ))
                                                                            :
                                                                            dynamic.field_value && dynamic.field_value !== "" && dynamic.field_value !== "[]" && !Array.isArray(dynamic.field_value) &&
                                                                                JSON.parse(dynamic.field_value).map((fields: any, index: any) => (
                                                                                    <ul key={ind+index} className={carouselStyles.dynamic_list_style}>
                                                                                        <li>
                                                                                            {Object.values(fields)[0] as String}
                                                                                            <ul className={carouselStyles.dynamic_sub_list_style}>
                                                                                                {Object.entries(fields)
                                                                                                    .slice(1)
                                                                                                    .map(([key, value], indexx) => (
                                                                                                        <li key={ind+index+indexx}>
                                                                                                            {key}: 
                                                                                                            <span 
                                                                                                                className={carouselStyles.ternary_textfield_style}
                                                                                                                style={{color: image?.item_style?.field_value_color ? `${image?.item_style?.field_value_color}` : "#7A7A7A"}}
                                                                                                            >
                                                                                                                {` ${value}`}
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    ))}
                                                                                            </ul>
                                                                                        </li>
                                                                                    </ul>
                                                                                ))
                                                                            : 
                                                                            <span 
                                                                                className={carouselStyles.ternary_textfield_style}
                                                                                style={{
                                                                                    color: image?.item_style?.field_value_color ? `${image?.item_style?.field_value_color}` : dynamic?.flag_url ? "blue" : "#7A7A7A",
                                                                                    fontStyle: dynamic?.flag_url ? "italic" : ""
                                                                                }}
                                                                                onClick={() => {dynamic?.flag_url && window.open(dynamic.field_value, "_blank")}}
                                                                            >
                                                                                {/* {dynamic?.flag_url ? dynamic?.url_text != "" ? dynamic?.url_text : dynamic?.field_value : (dynamic?.field_value === "" || dynamic?.field_value == "[]" ) ? "-" : dynamic?.field_value} */}
                                                                                {getDynamicValue(dynamic)}
                                                                            </span>
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        )
                                                    }

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {convertKeysToLowerCase(currentCartData)?.cta_buttons && convertKeysToLowerCase(currentCartData)?.cta_buttons?.map((button: any, ind: number) => {
                return <Grid key={ind} container mt={0}>
                    <Divider style={{ width: '100%' }} />
                    <Grid item xs={12} className={styles.chat_crl_media_item} sx={{ cursor: "pointer" }}>
                        <Grid container sx={{ justifyContent: 'center', opacity: (button?.flag_disabled == "true") ? "0.5" : "1" }} onClick={() => { handleActionButton(button) }}>
                            {getActionButtonIcon(button.message_format_id)}

                            <Typography
                                component="span"
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    color: '#2E79BD',
                                    marginLeft: "5px !important",
                                }}
                            >
                                {button.message_fields.url_text}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            })
            }
        </Grid>
    )
}

export default CardCarouselDynamicFormatCTA